export default {
  header: {
    title: 'Rabatkode eller gavekort',
  },
  available_codes: {
    title_one: 'Tilgængelig kode ({{count}})',
    title_other: 'Tilgængelige koder ({{count}})',
    min_threshold: 'Min. {{value}}',
    percentage_off: '{{discount}}% rabat på denne ordre',
    amount_off: '{{amount}} rabat på denne ordre',
  },
  content: {
    input: {
      placeholder: 'Indtast en kode',
    },
    buttons: {
      done: 'Færdig',
      apply: 'Anvend',
      applied: 'Anvendt ✓',
    },
  },
};
